import {hideLoader, showLoader} from '../redux/slice/loaderSlice';
import {loggedOut} from '../redux/slice/loginSlice';
import {AppDispatch} from '../store';
import {formatDate} from '../util/DateUtil';
import requestErrorHandler, {ErrorJsonHandlerMap} from './requestErrorHandler';

const applicationJsonMediaType = 'application/json';

export const postJsonData = (url: string, body: string | undefined, dispatch: AppDispatch, throwError = false, baseUrl = window.environment.backend) => {
    dispatch(showLoader());

    const headers: HeadersInit = {};

    if (body) {
        headers['content-type'] = applicationJsonMediaType;
    }

    const request = fetch(baseUrl + url, {
        method: 'POST',
        credentials: 'include',
        headers,
        body
    }).then((response) => {

        if (!response.ok) {
            if (!throwError) {
                dispatch(hideLoader());
            }
            throw response;
        }

        dispatch(hideLoader());

        if (response.headers.get('Content-Type') !== null && response.headers.get('Content-Type') === 'application/json') {
            return response.json();
        }

        return response;
    });

    if (!throwError) {
        return requestErrorHandler(request, 'POST', dispatch);
    }

    return request;
};

export const jsonData = (url: string, method: string, handleError: boolean, dispatch: AppDispatch, statusHandler: ErrorJsonHandlerMap = {},
                         baseUrl = window.environment.backend, acceptHeader = applicationJsonMediaType) => {
    const headers = new Headers();

    return jsonDataWithHeader(url, method, handleError, dispatch, headers, statusHandler, baseUrl, acceptHeader);
};

export const jsonDataWithHeader = (url: string, method: string, handleError: boolean, dispatch: AppDispatch, headers: Headers, statusHandler: ErrorJsonHandlerMap = {},
                                   baseUrl = window.environment.backend, acceptHeader = applicationJsonMediaType) => {
    dispatch(showLoader());

    if (acceptHeader) {
        headers.set('Accept', acceptHeader);
    }

    const request = fetch(baseUrl + url, {
        method: method,
        credentials: 'include',
        headers
    }).then((response) => {
        if (response.status === 401 || response.status === 403) {
            window.sessionStorage.setItem('notLoggedInLocation', window.location.toString());
            dispatch(loggedOut());
        }

        if (!response.ok) {
            if (!handleError) {
                dispatch(hideLoader());
            }
            throw response;
        }

        dispatch(hideLoader());

        if (acceptHeader === applicationJsonMediaType) {
            return response.json();
        }

        return Promise.resolve(response);
    });

    if (handleError) {
        return requestErrorHandler(request, method, dispatch, statusHandler);
    }

    return request;
};

export const getJsonData = (url: string, dispatch: AppDispatch, statusHandler: ErrorJsonHandlerMap = {}, acceptHeader = applicationJsonMediaType) => {
    return jsonData(url, 'GET', true, dispatch, statusHandler, undefined, acceptHeader);
};

export const postDataOauthNoError = (url: string, dispatch: AppDispatch) => {
    return postJsonData(url, undefined, dispatch, false, window.environment.oAuthBase);
};

export const deleteJsonData = (url: string, dispatch: AppDispatch) => {
    return jsonData(url, 'DELETE', true, dispatch);
};

export const postFormData = (url: string, data: FormData, dispatch: AppDispatch, throwError = false) => {
    dispatch(showLoader());
    const request = fetch(window.environment.backend + url, {
        method: 'POST',
        credentials: 'include',
        body: data
    }).then((response) => {

        if (!response.ok) {
            if (!throwError) {
                dispatch(hideLoader());
            }
            throw response;
        }
        dispatch(hideLoader());

        return response.json();
    });
    if (!throwError) {
        return requestErrorHandler(request, 'POST', dispatch);
    }
    return request;
};

export const downloadExcel = (url: string, body: string | undefined, dispatch: AppDispatch, throwError = false, exportName?: string) => {
    dispatch(showLoader());

    const headers: HeadersInit = {};

    if (body) {
        headers['content-type'] = applicationJsonMediaType;
    }

    const request = fetch(window.environment.backend + url, {
        method: 'POST',
        credentials: 'include',
        headers,
        body
    }).then((response) => {

        if (!response.ok) {
            if (!throwError) {
                dispatch(hideLoader());
            }
            throw response;
        }

        dispatch(hideLoader());

        return response.blob();
    }).then(blob => {
        const objUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objUrl;
        // a date e.g. 24.04.2022 will return as 2022-04-24
        const today = formatDate(new Date(Date.now())).split('.').reverse().join('-');
        a.download = `${today}_${exportName ?? 'report_export'}.xlsx`;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
    });

    if (!throwError) {
        return requestErrorHandler(request, 'POST', dispatch);
    }
    return request;
};
